//import { useState } from "react";
import { useLayoutEffect, useState } from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
//import ResetForm from "./ResetForm";
// import PttLogo from "../../static/icon/Ptt_login_logo";
//import ComfirmPage from "./ComfirmPage";
import Background from '../../../assets/Images/png/bg-new-password.svg';
import SuccessForm from './SuccessForm';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const ForgotPassword = ({ history }) => {
    const [currentPageAction, setCurrentPageAction] = useState({
        name: 'FORGOT',
        mail: '',
        text: '',
    });
    const { i18n } = useTranslation();
    useLayoutEffect(() => {
        document.body.style.background = `#fff url(${Background}) no-repeat center fixed`;
        document.body.style.backgroundSize = `cover`;
        document.body.style.width = '100%';
        document.body.style.height = '100vh';
        document.body.position = 'relative';
    });
    return (
        <div>
            <div className="m-auto w-sm">
                <div className="absolute top-8 right-10 text-sm z-30">
                    <span
                        className={classNames('cursor-pointer mx-2', {
                            'p-0.5 px-1 rounded-md text-white bg-purple':
                                i18n.language === 'th',
                        })}
                        onClick={() => i18n.changeLanguage('th')}
                    >
                        TH
                    </span>
                    |
                    <span
                        className={classNames('cursor-pointer  mx-2 ', {
                            'p-0.5 px-1 rounded-md text-white bg-purple':
                                i18n.language === 'en',
                        })}
                        onClick={() => i18n.changeLanguage('en')}
                    >
                        EN
                    </span>
                </div>
                <div className="absolute h-full grid items-center justify-center m-auto">
                    <div
                        className="bg-white"
                        style={{ borderRadius: '7px', height: '75%' }}
                    >
                        {currentPageAction.name === 'FORGOT' ? (
                            <ForgotPasswordForm
                                history={history}
                                currentPageAction={currentPageAction}
                                setCurrentPageAction={setCurrentPageAction}
                            />
                        ) : (
                            <SuccessForm
                                currentPageAction={currentPageAction}
                                setCurrentPageAction={setCurrentPageAction}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
